import { Device } from '@capacitor/device';

const LATEST_URL = '/latest.json';
const APK_PATH = '/shepherds-v-1.0.apk';

export async function checkForUpdate() {
  let appBuild = 0;
  try {
    const info = await Device.getInfo();
    appBuild = Number(info?.appBuild || 0);
  } catch {}

  let meta = null;
  try {
    const res = await fetch(LATEST_URL, { cache: 'no-store' });
    meta = await res.json();
  } catch {}

  const serverCode = Number(meta?.versionCode || 0);
  const update = serverCode > appBuild;

  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const apkUrl = origin + APK_PATH;

  return { update, meta: { ...meta, apkUrl } };
}
